module.exports = __webpack_public_path__ + "static/media/delete_vault.796cde96.svg";